export default "__VITE_ASSET__720dc039__"